import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const NavItem = ({ navigation, index, isActive, onClick }) => (
  <div
    key={index}
    className={`
      group flex items-center gap-4 px-6 py-3 mx-3 rounded-xl transition-all duration-200 text-sm font-medium cursor-pointer
      ${isActive 
        ? 'bg-white text-blue-700 shadow-lg' 
        : 'text-gray-300 hover:bg-white/10 hover:text-white'
      }
    `}
    onClick={() => {
      if (onClick) onClick();
    }}
  >
    <span className={`text-lg ${isActive ? 'text-blue-600' : 'text-gray-400 group-hover:text-white'}`}>
      {navigation.icon}
    </span>
    <span className="truncate">{navigation.name}</span>
  </div>
);

export default NavItem;
